import React, { Component } from 'react'
import withBulkAction from '../with-bulk-action/with-bulk-action'
import SelectAll from 'pobble-components/dist/select-all'

class SelectAllButton extends Component {
  render() {
    const {
      bulkAllSelected,
      bulkSelectAll,
      bulkDeselectAll,
      bulkSelectedList,
      className,
      style
    } = this.props
    return (
      <SelectAll
        className={className}
        style={style}
        deselect={!!bulkSelectedList.length && bulkAllSelected}
        onSelect={bulkSelectAll}
        onDeselect={bulkDeselectAll}
      />
    )
  }
}

export default withBulkAction(SelectAllButton)
